import { useEffect, useRef, useState } from 'react';

declare global {
    interface Window {
        naver: any;
    }
}

const NaverLoginButton = () => {
    const naverRef = useRef<HTMLDivElement>(null);
    const [isHovered, setIsHovered] = useState(false);

    const initializeNaverLogin = () => {
        const script = document.createElement('script');
        script.src =
            'https://static.nid.naver.com/js/naverLogin_implicit-1.0.3.js';
        script.charset = 'utf-8';
        script.async = true;
        document.head.appendChild(script);

        script.onload = () => {
            const naverLogin = new window.naver.LoginWithNaverId({
                clientId: import.meta.env.VITE_NAVER_CLIENT_ID,
                callbackUrl: import.meta.env.VITE_NAVER_CALLBACK_URL,
                isPopup: false,
                loginButton: {
                    color: 'green',
                    type: 3,
                    height: 40,
                },
            });
            naverLogin.init();
        };

        return () => {
            document.head.removeChild(script);
        };
    };

    useEffect(() => {
        initializeNaverLogin();
    }, []);

    const handleNaverLogin = () => {
        if (naverRef.current?.children[0]) {
            (naverRef.current.children[0] as HTMLElement).click();
        }
    };

    return (
        <>
            {/* 네이버 기본 버튼 - 숨김 처리 (기능은 유지) */}
            <div ref={naverRef} id="naverIdLogin" style={{ display: 'none' }} />

            {/*
             * 공식 NAVER BI 가이드 준수
             * - 배경색: NAVER Green (#03C75A) / RGB 3, 199, 90 / PANTONE 2270C
             * - 텍스트 & 심볼: 흰색 (#FFFFFF) - 어두운 배경 규정
             * - N 심볼: 비율 유지, 형태·색상 임의 변형 금지
             * - 레이블: "네이버로 로그인" (완성형)
             * - 그라데이션·외곽선 효과 적용 금지
             */}
            <button
                onClick={handleNaverLogin}
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '8px',
                    width: '100%',
                    height: '45px',
                    /* NAVER 공식 그린: HEX #03A94D / RGB 3, 199, 90 / CMYK 72 0 88 0 */
                    backgroundColor: isHovered ? '#02B350' : '#03A94D',
                    border: 'none',
                    borderRadius: '4px',
                    cursor: 'pointer',
                    color: '#FFFFFF',
                    fontSize: '14px',
                    fontWeight: '700',
                    letterSpacing: '-0.3px',
                    padding: '0 16px',
                    transition: 'background-color 0.15s ease',
                    userSelect: 'none',
                }}
                aria-label="네이버로 로그인"
            >
                {/*
                 * NAVER N 심볼 SVG
                 * 가이드: 비율(1:1) 유지, 흰색 적용 (녹색 배경 위 기준)
                 * 출처: developers.naver.com/docs/login/bi/bi.md
                 */}
                <svg
                    role="img"
                    aria-label="NAVER"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    width="16"
                    height="16"
                    fill="#FFFFFF"
                    style={{ flexShrink: 0 }}
                >
                    <path d="M16.273 12.845L7.376 0H0v24h7.727V11.155L16.624 24H24V0h-7.727z" />
                </svg>
                <span style={{ fontSize: '15px', fontWeight: '400' }}>
                    네이버로 로그인
                </span>
            </button>
        </>
    );
};

export default NaverLoginButton;
